import { X } from 'lucide-react';
import * as React from 'react';

import { ToggleButton } from '@/components/ui/toggle-button/toggle-button';

export const BhanzuBuddyHeader: React.FC<{
  currentMode: 'explain' | 'guide';
  onToggleMode: (mode: 'explain' | 'guide') => void;
  onClose: () => void;
}> = ({ currentMode, onToggleMode, onClose }) => {
  return (
    <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-700/50">
      <h1 className="text-white text-xl sm:text-2xl font-semibold">
        Bhanzu Buddy
      </h1>
      <div className="flex items-center gap-3">
        <ToggleButton
          options={[
            { value: 'explain', label: 'Explain' },
            { value: 'guide', label: 'Guide' },
          ]}
          value={currentMode}
          onChange={(value: string) =>
            onToggleMode(value as 'explain' | 'guide')
          }
          size="md"
        />
        <button
          type="button"
          onClick={onClose}
          className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-colors"
          aria-label="Close chat"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};
